exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-full {\n  min-width: 250px;\n  border-radius: 10px;\n}\n.button-full:hover {\n  background-color: rgba(17, 187, 46, 0.8);\n}\n", ""]);

// exports
